import { render, staticRenderFns } from "./ComparativeTableCell.vue?vue&type=template&id=2d7780fe&scoped=true"
import script from "./ComparativeTableCell.vue?vue&type=script&lang=js"
export * from "./ComparativeTableCell.vue?vue&type=script&lang=js"
import style0 from "./ComparativeTableCell.vue?vue&type=style&index=0&id=2d7780fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7780fe",
  null
  
)

export default component.exports